import { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { Empty } from "@/components/ui-kit";
import { fmtTime } from "@/components/Pager";
import { toast } from "sonner";
import { Bus } from "lucide-react";
import { card, usePoll, LocationNote, BusMap } from "./common";

export function LivePanel({ branchId }) {
  const [vs, setVs] = useState([]);
  usePoll(() => branchId && api.get("/transport/live", { params: { branch_id: branchId } }).then((r) => setVs(r.data)).catch((e) => toast.error(formatApiError(e))), 15000, [branchId]);
  if (!vs.length) return <Empty testid="live-empty" icon={Bus} text="No vehicles added yet." />;
  return (
    <div className="space-y-4">
      <BusMap testid="live-map" height={380} buses={vs.map((v) => ({ id: v.id, label: v.reg_no, loc: v.last_location }))} />
      <div className="grid md:grid-cols-2 gap-3">
        {vs.map((v) => (
          <div key={v.id} data-testid={`live-${v.id}`} className={`${card} space-y-1`}>
            <div className="flex items-center gap-2">
              <span className="font-display font-bold text-violet-800">{v.reg_no}</span>
              <span className="text-xs text-slate-500">{v.route?.name || "No route"}</span>
              {v.trip ? <Badge className="ml-auto bg-emerald-100 text-emerald-800">{v.trip.kind} • since {fmtTime(v.trip.started_at)}</Badge> : <Badge className="ml-auto bg-slate-100 text-slate-600">Idle</Badge>}
            </div>
            <div className="text-sm text-slate-600">Driver: {v.driver ? `${v.driver.name} (${v.driver.phone})` : "—"} • Attendant: {v.attendant ? `${v.attendant.name} (${v.attendant.phone})` : "—"}</div>
            <LocationNote loc={v.last_location} testid={`live-loc-${v.id}`} />
          </div>
        ))}
      </div>
    </div>
  );
}
